import {axiosInstance} from "./axiosInstance";

export const getUserBalance = async (gameId) => {
    const response = await axiosInstance.get(`/api/v1/Users/Balance`, {
        params: {gameId}
    })
    return response.data
}

export const getUserSpinsHistory = async (page, gameId, pageSize = 30) => {
    const response = await axiosInstance.get(`/api/v1/Spins`, {
        params: {gameId, pageSize, page},
    })

    return response.data
}

export const postBuyFreeSpins = async ({gameId, amount}) => {
    const response = await axiosInstance.post(`/api/v1/FreeSpins`, {gameId, amount}, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return response.data;
}

export const postBuyFreeSpinsDemo = async ({gameId, amount}) => {
    const response = await axiosInstance.post(`/api/v1/FreeSpins/Demo`, {gameId, amount}, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return response.data;
}

export const getOtherGames = async (gameId) => {
    const response = await axiosInstance.get(`/api/v1/Games`, {
        params: {gameId},
    })

    return response.data.data
}

export const getFreeBets = async (gameId) => {
    const response = await axiosInstance.get(`/api/v1/FreeBets`, {
        params: {gameId},
    })

    return response.data.data
}
